module.exports = __webpack_public_path__ + "img/safeAndSecureIcon.e21e4539.png";